import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TimeDisplayState } from './time-display.reducers';

export const timeDisplayState = createFeatureSelector<TimeDisplayState>('timeDisplay');

export const timeDisplaySelector = createSelector(timeDisplayState, timeDisplay => timeDisplay.time);
